import './index.css';
import MujahidUmrahWebsite from './components/MujahidUmrahWebsite';

function App() {
  return (
    <div className="App">
      <MujahidUmrahWebsite />
    </div>
  );
}

export default App;